import React from "react";
import { CreatedBy } from "../PublicViewRender";
import abLogo from "../../../../../assets/abLargeGoldenLogo.png";
import siteIntroBanner from "../../../../../assets/siteIntroBanner.png";
import ImgOptimized from "../../../../../components/ImgOptimized";
const IndexPage = ({
  heading,
  fields = [],
  createdBy,
  creationDate,
  isPdf,
  width,
}) => {
  return (
    <div className="w-full h-full bg-white flex flex-col gap-0 relative">
      <div
        className={`bg-[#06565E] playfair text-[#EABC9D] text-xl sm:text-3xl text-center font-bold italic py-1 sm:py-2 `}
      >
        <>
          {isPdf ? (
            <span className="text-center w-full relative bottom-3.5">
              {heading}
            </span>
          ) : (
            <>{heading}</>
          )}
          <div className="absolute top-0 left-0">
            <ImgOptimized src={abLogo} className="w-20 sm:w-28" />
          </div>
        </>
      </div>
      <div
        className={`grow min-h-0 relative grid grid-cols-2 overflow-hidden  ${
          isPdf && "bottom-1"
        }`}
      >
        <div className="w-full h-full flex flex-col items-center justify-center px-4">
          {fields.map((v) => (
            <div className="w-full border-b-black/50 border-b-[0.5px] py-1 capitalize playfair font-[500] text-xs sm:text-sm md:text-base ">
              {v.toLowerCase()}
            </div>
          ))}
        </div>
        <div
          style={{
            backgroundImage: `url(${siteIntroBanner})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
          className="w-full h-full "
        ></div>
      </div>
      <div
        className={`absolute ${
          isPdf ? "-bottom-1 -left-1" : "-bottom-2 -left-3"
        }  w-fit text-nowrap `}
      >
        <CreatedBy username={createdBy} date={creationDate} isPdf={isPdf} />
      </div>
    </div>
  );
};

export default IndexPage;
